module.exports = __webpack_public_path__ + "img/home@2x.65d30b3b.png";